import React,{useEffect,useState} from 'react';
import "./Main.scss"
import Community from '../Community/Community';
//https://cors-anywhere.herokuapp.com/

export default function Main() {

    const [com, setCom] = useState("family")
    
    useEffect(() => {}, [com])
    useEffect(() => {
        switch(com){
            case "family":
                document.querySelector(`.w2`).style.border = "1px solid #c66011";
                document.querySelector(`.w1`).style.border = "1px solid transparent";
                document.querySelector(`.w3`).style.border = "1px solid transparent";
                break;
            case "env":
                document.querySelector(`.w3`).style.border = "1px solid #98b529";
                document.querySelector(`.w1`).style.border = "1px solid transparent";
                document.querySelector(`.w2`).style.border = "1px solid transparent";
                break;
            case "nut":
                document.querySelector(`.w1`).style.border = "1px solid #d8a727";
                document.querySelector(`.w2`).style.border = "1px solid transparent";
                document.querySelector(`.w3`).style.border = "1px solid transparent";
                break;
            default:
                document.querySelector(`.${com}`).style.border = "";
                return;
        }
    }, [com])

    return (
        <section className="main">
            <div className="welcome">
                <div className="a_wrapper">
                    <a href="mailto: izunbahaim@gmail.com" className="email"></a>
                </div>
            </div>
            <div className="three_coms">
                <div className="cube_wrapper w1">
                    <div className="nut cube" onClick={() => setCom("nut")}></div>
                </div>
                <div className="cube_wrapper w2">
                    <div className="family cube" onClick={() => setCom("family")}></div>
                </div>
                <div className="cube_wrapper w3">
                    <div className="env cube" onClick={() => setCom("env")}></div>
                </div>
            </div>
            <Community community={com}/>
        </section>
    )
}
